import React, { useEffect, useRef } from 'react'
import L from 'leaflet'
import './markerPulse'
import './markerPulse.css'
//react-google-maps
import MarkerClusterGroup from 'react-leaflet-markercluster'
import 'react-leaflet-markercluster/dist/styles.min.css';
//ticatag
import LocationMarker from './locationMarker'
import { getMarkerDefaultIcon } from './icons'







const getMarkerSelectIcon = (iconColor) => {

  if (iconColor) {
    return new L.Icon.Pulse({
      fillColor: iconColor,
      color: iconColor,
    })
  }

  return new L.Icon.Pulse({
    fillColor: 'blue',
    color: 'blue',
  })
}

/**
 * Cluster icon: the plugin's default (count + small/medium/large class), plus a pulsing ring
 * when one of the clustered markers is the selected location, so the user can tell which
 * cluster hides the selected point. The ring takes the cluster's own colour (see markerPulse.css).
 */
export const createClusterIcon = (cluster, selectedId) => {
  const count = cluster.getChildCount()
  const size = count < 10 ? 'small' : count < 100 ? 'medium' : 'large'
  const holdsSelection = selectedId != null &&
    cluster.getAllChildMarkers().some((m) => m.options && m.options.locationId === selectedId)
  return new L.DivIcon({
    html: `<div><span>${count}</span></div>`,
    className: `marker-cluster marker-cluster-${size}${holdsSelection ? ' marker-cluster-selected' : ''}`,
    iconSize: new L.Point(40, 40),
  })
}





const MarkerClusterer = (props) => {

  const { handleSelect, scrollYContainerRef, scrollXContainerRef, locations, idSelected, disableClusteringAtZoom } = props

  // The cluster group reads the selection through a ref: its options are fixed at creation and
  // the icon function must still see the current selection when clusters are (re)built.
  const groupRef = useRef(null)
  const selectedIdRef = useRef(null)
  selectedIdRef.current = idSelected

  // Rebuild the cluster icons when the selection changes.
  useEffect(() => {
    const group = groupRef.current
    if (group && typeof group.refreshClusters === 'function') {
      group.refreshClusters()
    }
  }, [idSelected])

  const renderMarker = (location, idSelected, index) => {

    if (location && location.id && location.lat && location.lng) {
      const icon = location.id === idSelected ? getMarkerSelectIcon(location.iconColor) : getMarkerDefaultIcon(location.iconName, location.iconColor);
      return (
        <LocationMarker
          icon={icon}
          iconColor={location.iconColor}
          // Keyed by id, not by index: the Leaflet marker (and its creation-only `locationId`
          // option) must stay attached to the same location when the list changes.
          key={`loc-${location.id}`}
          index={index}
          handleSelect={handleSelect}
          scrollYContainerRef={scrollYContainerRef}
          scrollXContainerRef={scrollXContainerRef}
          location={location}
          selected={location.id === idSelected}

        />
      )
    } else {
      return <div key={`idx-${index}`} />
    }
  }



  if (!locations || (locations && locations.length === 0)) {
    return null
  }


  return (
    <MarkerClusterGroup
      ref={groupRef}
      key={disableClusteringAtZoom * 200}
      disableClusteringAtZoom={disableClusteringAtZoom}
      iconCreateFunction={(cluster) => createClusterIcon(cluster, selectedIdRef.current)}
    >
      {locations.map((location, index) => renderMarker(location, idSelected, index))}
    </MarkerClusterGroup>

  )


}



export default MarkerClusterer;
